<template>
  <v-list-group>
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title>Installation</v-list-item-title>
      </v-list-item-content>
      <div v-if="installation.length > 0">
        <v-badge color="brown" :content="installation.length"> </v-badge>
      </div>
    </template>
    <v-list-item v-for="(list, i) in listInstallation" :key="i">
      <v-checkbox
        v-model="installation"
        :label="list.name"
        @change="filterDataType('installation', $event)"
        :value="list.value"
        hide-details
      >
      </v-checkbox>
    </v-list-item>
  </v-list-group>
</template>

<script>
import { EventBus } from "@/utils/eventBus";
import { debounce } from "@/utils/format";

export default {
  name: "NavigationInstallation",
  data() {
    return {
      installation: [],
      listInstallation: [
        {
          name: "Complete",
          value: "complete"
        },
        {
          name: "Incomplete",
          value: "incomplete"
        },
        {
          name: "Need Request",
          value: "needrequest"
        }
      ]
    };
  },
  created() {
    EventBus.$on("TYPE_RESET", value => {
      if (value == "reset") {
        this.installation = [];
      }
    });
  },
  methods: {
    filterDataType: debounce(function(type, data) {
      EventBus.$emit("TYPE_EVENT", { type, data });
    }, 1000)
  }
};
</script>
